// extracted by mini-css-extract-plugin
export default {"addPartner":"styles_addPartner__rs48p","inner":"styles_inner__ISmKE","addWrapper":"styles_addWrapper__gJst8","add":"styles_add__ObX2h","plusIcon":"styles_plusIcon__r1OSZ"};